import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';
import { TelegramAccountEntity } from '../../../domain/entities/TelegramAccount';

export class CreateTelegramAccountUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(input: { phone: string }): Promise<TelegramAccountEntity> { return this.repo.create(input); }
}
